import { onBeforeUnmount } from "vue";
import deepEqual from "fast-deep-equal";
import { endOfDay } from "date-fns";
import debounce from "lodash.debounce";
import store from "@/store";
import router from "@/router";
import apiFetchNewsItems from "@/store/modules/newsItems/fetchNewsItems";
import intervalId from "./pollingState";

// TODO: testing of polling logic, e.g. integration/e2e tests
export default () => {
  const POLLING_INTERVAL = 30000; // Every 30 seconds
  const POLLING_OFFSET = 5 * 60 * 1000; // Offset query by 5 minutes
  const setPollingInterval = debounce(() => {
    if (intervalId.value) {
      clearTimeout(intervalId.value);
      intervalId.value = undefined;
    }
    if (intervalId.value === undefined) {
      intervalId.value = setTimeout(async () => {
        const firstNewsItem = store.state.newsItems.newsItems[0];
        const isPollingEnabled =
          store.state.stageconfig.config?.features?.enablePolling &&
          firstNewsItem &&
          router.currentRoute.query.sortOrder === "desc";

        if (isPollingEnabled) {
          const authJWT = store.getters["auth/validateAndRetrieveToken"]();
          if (!authJWT) {
            store.dispatch("auth/logout");
          }

          const url = "newsitems?autoRefresh=true";
          const filterRules = [...store.state.filterRules.filterRules];
          const from = new Date(
            firstNewsItem.versionCreated.getTime() - POLLING_OFFSET
          ).toISOString();
          const to = new Date(
            endOfDay(router.currentRoute.query.endDate)
          ).toISOString();
          const sortOrder = "desc";
          const maxResults = 100;
          const version = "/api/v2";

          const pollingTimeStamp = performance.now();
          const { remoteContent, newsItems } = await apiFetchNewsItems({
            url,
            payload: {
              from,
              to,
              sortOrder,
              filterRules,
              maxResults
            },
            authJWT,
            version
          });

          if (
            !store.state.newsItems.isLoading &&
            deepEqual(filterRules, store.state.filterRules.filterRules) &&
            pollingTimeStamp > store.state.newsItems.searchTimeStamp
          ) {
            store.commit("newsItems/mergeNewsItems", newsItems);
            store.commit("newsItems/mergeRemoteContent", remoteContent);
          }
        }
        setPollingInterval();
      }, POLLING_INTERVAL);
    }
  }, 500);

  onBeforeUnmount(() => {
    if (intervalId.value) {
      clearTimeout(intervalId.value);
    }
  });

  return { setPollingInterval };
};
